import { useEffect, useRef, useState } from 'react';

export interface SidebarSectionOption {
  key: string;
  label: string;
  // Rubrique dont les données ne sont pas accessibles en l'état (ex. Tickets Jira sans token
  // Jira configuré, ou sans les droits suffisants) — affichée grisée et non cliquable plutôt que
  // masquée du menu, pour que l'utilisateur sache que la rubrique existe et pourquoi elle est
  // indisponible (voir disabledReason).
  disabled?: boolean;
  disabledReason?: string;
}

export function SidebarSectionsMenu({
  options,
  visible,
  onToggle,
}: {
  options: SidebarSectionOption[];
  visible: Set<string>;
  onToggle: (key: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div className="sidebar-sections-menu" ref={ref}>
      <button
        className="sidebar-sections-toggle"
        onClick={() => setOpen((v) => !v)}
        title="Rubriques affichées"
      >
        ☰
      </button>
      {open && (
        <div className="sidebar-sections-dropdown">
          {options.map((opt) => (
            <button
              key={opt.key}
              type="button"
              role="menuitemcheckbox"
              aria-checked={visible.has(opt.key)}
              disabled={opt.disabled}
              className="sidebar-sections-item"
              title={opt.disabled ? opt.disabledReason : undefined}
              onClick={() => {
                if (opt.disabled) return;
                onToggle(opt.key);
                setOpen(false);
              }}
            >
              <span className="sidebar-sections-check">{visible.has(opt.key) ? '✓' : ''}</span>
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
